import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import CssBaseline from '@material-ui/core/CssBaseline'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import styles from './app-container.scss'
import { APP_STORE } from '../store/stores'
import { AppStore } from '../store/app/app-store'
import { Progress } from './progress/progress'

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
            light: '#9AE9F3',
            main: '#00BCD4',
            dark: '#00515F',
            contrastText: '#FFFFFF',
        },
        secondary: {
            light: '#9AE9F3',
            main: '#607D8B',
            dark: '#00515F',
            contrastText: '#FFFFFF',
        },
    },
    overrides: {
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: '#8E1538'
            }
        }
    }
})

@inject(APP_STORE)
@observer
export default class AppContainer extends Component {

    static propTypes = {
        children: PropTypes.node,
        appStore: PropTypes.instanceOf(AppStore)
    }

    render() {
        const { children, appStore } = this.props
        const { loading } = appStore

        return (
            <MuiThemeProvider theme={theme}>
                <CssBaseline/>
                <div className={styles.appContainer}>
                    <Progress
                        visible={loading}
                        minVisibleTimeMs={400}
                        maxInvisibleTimeMs={100}
                    />
                    {children}
                    {appStore.devTools}
                </div>
            </MuiThemeProvider>
        )
    }
}
